export const getColorByRadioValue = value => {
  let color;
  let backgroundColor;
  if (value > 30) {
    backgroundColor = "#D4FE75";
    color = "#54535D";
  } else if (value <= 30 && value > 8) {
    backgroundColor = "#FFC107";
    color = "#FFFFFF";
  } else if (value <= 8) {
    backgroundColor = "#F8465E";
    color = "#FFFFFF";
  } else {
    backgroundColor = "transparent";
    color = "inherit";
  }
  return { color, backgroundColor };
};
